import instance from './base.service';

export const leaveFeedback = async (params) => {
  try {
    const { contentRequestId, requestTryNumber, ...feedback } = params;
    const url = `/content-requests/${contentRequestId}/tries/${requestTryNumber}/generated-content`;

    return await instance.patch(url, { feedback });
  } catch (error) {
    console.log(error);
  }
};
